'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedReactMessage',

  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,

  getEscapedParam: function getEscapedParam(param, key, index) {
    if (!_react2.default.isValidElement(key)) {
      return _react2.default.createElement('span', {
        dangerouslySetInnerHTML: { __html: _I18n2.default.formatParam(param, key) },
        key: param + '-' + index
      });
    }

    return _react2.default.cloneElement(key, {
      key: param + '-' + index,
      ref: key.ref
    });
  },
  renderFormattedMessage: function renderFormattedMessage() {
    return _I18n2.default.interpolateToArray(this.props.message, this.props.options, this.getEscapedParam);
  },
  render: function render() {
    var props = (0, _utils.getPassThroughProps)(this.props);
    return _react2.default.createElement(
      'span',
      props,
      this.renderFormattedMessage()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.433/js/components/FormattedReactMessage.js
// module id = 579
// module chunks = 3 4